import { Component, input, ChangeDetectionStrategy } from "@angular/core";
import { TableItem } from "./column.model";
import { TableFieldType } from "../../forms/table-field/table-field.model";

@Component({
    selector: "app-column",
    templateUrl: "./column.component.html",
    styleUrls: ["./column.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ColumnComponent {
  readonly columnForm = input<TableItem>(undefined);
  readonly index = input<number>(undefined);

  TableFieldTypes = TableFieldType;
}
